import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import Select, { GroupBase } from 'react-select';
import { SelectComponents } from 'react-select/dist/declarations/src/components';

import { BaseInputFieldProps } from '../BaseInputField';
import { BaseWrapper } from '../BaseWrapper';
import './react-select.css';

type SelectValue = Record<string, unknown> | string;

export type SelectOption<T extends SelectValue = SelectValue> = {
  value: T;
  label: string;
};

const allOption = {
  label: 'Select all',
  value: 'all',
};

export const SelectField = ({
  title,
  name,
  options,
  isMulti,
  isClearable,
  allowSelectAll,
  disabled,
  components,
  ...props
}: BaseInputFieldProps & {
  isMulti?: boolean;
  allowSelectAll?: boolean;
  isClearable?: boolean;
  components?: Partial<SelectComponents<any, boolean, GroupBase<any>>>;
  options: SelectOption[];
}) => {
  const { control } = useFormContext();
  return (
    <BaseWrapper title={title} name={name} {...props}>
      <Controller
        name={name}
        control={control}
        rules={{ required: props.required }}
        render={({ field }) => (
          <Select
            isDisabled={disabled}
            value={
              isMulti
                ? field.value
                  ? options.filter(({ value }) => field.value.includes(value))
                  : undefined
                : options.find(({ value }) => value === field.value)
            }
            options={allowSelectAll ? [allOption, ...options] : options}
            isMulti={isMulti}
            className="sm:text-sm"
            classNamePrefix="react-select-override"
            styles={{
              control: (provided) => ({
                ...provided,
                borderColor: '',
                borderRadius: '',
              }),
              placeholder: (provided) => ({
                ...provided,
                marginLeft: '',
                color: '',
              }),
              valueContainer: (provided) => ({
                ...provided,
                padding: '',
              }),
            }}
            isClearable={isClearable}
            onChange={(value) => {
              if (isMulti) {
                if (value === null) {
                  field.onChange([]);
                } else {
                  // @ts-expect-error
                  const v = value?.map(({ value }) => value);
                  field.onChange(v.length === 0 ? null : v);
                }
              } else {
                const v = value?.value;
                field.onChange(v);
              }
              if (allowSelectAll) {
                // @ts-expect-error
                if (value.find((option) => option.value === 'all')) {
                  const allOptions = options?.map(({ value }) => value);
                  field.onChange(allOptions);
                }
              }
            }}
            components={components}
          />
        )}
      />
    </BaseWrapper>
  );
};
